import {DEFAULT_LINE_PLOT_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {LinePlotDisplayFnArgs} from '../types';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';

export const getYLogScaleDisplayRow = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
}: LinePlotDisplayFnArgs) => {
  const currTemplateYLogScale = currTemplateLinePlotSettings?.yLogScale;
  const newTemplateYLogScale = currWorkspaceLinePlotSettings?.yLogScale;

  return {
    groupTitle: 'Y axis',
    label: 'Log scale',
    field: 'yLogScale' as keyof LinePlotTemplateSettings,
    currValue: currTemplateYLogScale,
    currDisplayValue:
      currTemplateYLogScale == null
        ? undefined
        : currTemplateYLogScale.toString(),
    newValue: newTemplateYLogScale ?? DEFAULT_LINE_PLOT_SETTINGS.yLogScale,
    newDisplayValue:
      newTemplateYLogScale == null
        ? DEFAULT_LINE_PLOT_SETTINGS.yLogScale.toString()
        : newTemplateYLogScale.toString(),
  };
};
